import Modal from "~/components/modal.tsx";
import useAppDispatch from "~/hooks/use-app-dispatch.ts";
import { guestLogout } from "~/features/user/store-slice.ts";
import { hideGuestPromo } from "./store-slice.ts";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";

type GuestPromoModalProps = {
	readonly show: boolean;
};

function GuestPromoModal({ show }: GuestPromoModalProps) {
	const dispatch = useAppDispatch();
	const t = useTranslator();

	const onGoBack = () => {
		dispatch(hideGuestPromo());
	};
	const onClose = () => {
		dispatch(hideGuestPromo());
		dispatch(guestLogout());
	};

	return (
		<Modal
			title={t("Enjoying the Brick Me Creator?")}
			show={show}
			onClose={onClose}
		>
			<Modal.Text>
				{t(
					"Enjoying the Brick Me Creator? As a registered user, you'll be able to create awesome brick mosaics using your own photos! Just sign in with your email address. Don't worry, we will never share your email and we won't send you marketing emails if you don't want us to.",
				)}
			</Modal.Text>
			<Modal.Actions
				actions={[
					{
						text: t("Go back and continue as a guest"),
						onClick: onGoBack,
						type: "ghost",
					},
					{
						text: t("Sign in and use my own photos!"),
						onClick: onClose,
						type: "ghost",
					},
				]}
			/>
		</Modal>
	);
}

export default GuestPromoModal;
